<div class="card">
	<div class="card-header" (click)="emitCollapse()">
		<h5 class="mb-0">
			<ng-content select="[title]"></ng-content>
		</h5>
		<i class="icon far fa-2x" [ngClass]="isOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
	</div>
	<div class="collapse" [class.hidden]="!isOpen">
		<div class="card-body">
			<ng-content></ng-content>
		</div>
	</div>
</div>
